"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryError = void 0;
var DeliveryError = /** @class */ (function () {
    function DeliveryError(data) {
        this.message = data.message;
        this.requestId = data.requestId;
        this.errorCode = data.errorCode;
        this.specificCode = data.specificCode;
    }
    return DeliveryError;
}());
exports.DeliveryError = DeliveryError;
//# sourceMappingURL=common-models.js.map